<template>
    <select
        :id="id"
        :class="['form-control', 'select2-enabled', 'select2-auto', controlClass]"
        :name="name"
        :data-placeholder="title"
        :title="title"
        :value="value"
    >
        <slot />
    </select>
</template>

<script>
'use strict';

import { _commons } from '../commons-global/index';

export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['controlClass', 'name', 'id', 'title', 'value', 'custom', 'nousertext'],
    data() {
        return {
            changing: false,
        };
    },
    watch: {
        value(newVal) {
            if(!this.changing) {
                $(this.$el).select2('val', newVal);
            }
        },
    },
    mounted() {
        if(this.custom) {
            _commons.bindCustomSelect($(this.$el), this.custom, { nousertext: this.nousertext });
        } else {
            $(this.$el).select2({ dropdownAutoWidth: true });
        }
        $(this.$el).on('change auto-changed', () => {
            this.changed();
        });
        this.$nextTick(() => {
            const value = $(this.$el).select2('val');
            const isEmpty = (!value && !this.value);
            if(!isEmpty && (value !== this.value)) {
                $(this.$el).select2('val', this.value);
            }
        });
    },
    beforeDestroy() {
        $(this.$el).select2('destroy');
    },
    methods: {
        changed() {
            const value = $(this.$el).select2('val');
            this.changing = true;
            try {
                this.$emit('input', value);
            } finally {
                this.changing = false;
            }
        },
    },
};
</script>
